import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class InputService {

  private serviceUrl:string;

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.serviceUrl = this.env.servicePath }

  changeInputValue(id:string, value:string):Observable<string>
  {
    var path = this.serviceUrl +"ChangeInputValue/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, value, httpOptions);
  }

  executeInputWorkflow(id:string):Observable<string>{
    var path = this.serviceUrl +"ExecuteInputWorkflow/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }
}
